// Contact.js

import React, { useState } from "react";
import api from "../../api/api";
import "./Contact.css";
import contactImage from "./papayatlantic.png";

import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setSuccess("");
    setError("");

    try {
      const response = await api.post("api/contact/", formData);

      setSuccess(
        response?.data?.message ||
          "Thank you for contacting us. We will get back to you shortly."
      );

      setFormData({
        full_name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (err) {
      console.error(err);

      setError(
        err?.response?.data?.message ||
          "Failed to send your message. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* MAIN CONTACT SECTION */}
      <section className="contact-main">
        {/* LEFT SIDE */}
        <div className="contact-left">
          <span className="section-tag">GET IN TOUCH</span>

          <h2>
            We’re Ready To Help Your Shipping Business Grow Efficiently
          </h2>

          <p>
            Whether you need freight forwarding, cargo handling, international
            shipping, or logistics support, our experienced team is available
            to assist you with fast and reliable service.
          </p>

          <div className="contact-info-wrapper">
            <div className="contact-info-card">
              <div className="contact-icon">
                <FaMapMarkerAlt />
              </div>

              <div>
                <h4>Office Location</h4>
                <p>
                  Monrovia, Liberia, Johnsonville, Pipeline Road, Kpelleh Town
                </p>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="contact-icon">
                <FaPhoneAlt />
              </div>

              <div>
                <h4>Call Us</h4>
                <p>+231 773 275 388 / +231 889 239 865</p>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="contact-icon">
                <FaEnvelope />
              </div>

              <div>
                <h4>Email Address</h4>
                <p>zulushipping@gmail.com</p>
              </div>
            </div>
          </div>

          {/* SOCIALS */}
          <div className="social-links">
            <a href="/">
              <FaFacebookF />
            </a>

            <a href="/">
              <FaInstagram />
            </a>

            <a href="/">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="contact-right">
          <img src={contactImage} alt="Shipping Company" />

          <div className="floating-card">
            <h3>Fast & Secure Delivery</h3>
            <p>
              Trusted cargo and shipping services with professionalism and
              customer satisfaction at the center.
            </p>
          </div>
        </div>
      </section>

      {/* CONTACT FORM SECTION */}
      <section className="contact-form-section">
        <div className="form-container">
          <div className="form-left">
            <h2>Send Us A Message</h2>

            <p>
              Fill out the form below and our support team will get back to you
              as soon as possible.
            </p>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="full_name"
                placeholder="Your Full Name"
                value={formData.full_name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <textarea
                rows="6"
                name="message"
                placeholder="Write Your Message..."
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>

            {success && (
              <div
                style={{
                  color: "#155724",
                  background: "#d4edda",
                  padding: "12px",
                  borderRadius: "6px",
                  marginBottom: "15px",
                }}
              >
                {success}
              </div>
            )}

            {error && (
              <div
                style={{
                  color: "#721c24",
                  background: "#f8d7da",
                  padding: "12px",
                  borderRadius: "6px",
                  marginBottom: "15px",
                }}
              >
                {error}
              </div>
            )}

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;




// // Contact.js

// import React from "react";
// import "./Contact.css";
// import contactImage from "./papayatlantic.png";

// import {
//   FaPhoneAlt,
//   FaEnvelope,
//   FaMapMarkerAlt,
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
// } from "react-icons/fa";

// const ContactPage = () => {
//   return (
//     <div className="contact-page">
//       {/* HERO SECTION */}


//       {/* MAIN CONTACT SECTION */}
//       <section className="contact-main">
//         {/* LEFT SIDE */}
//         <div className="contact-left">
//           <span className="section-tag">GET IN TOUCH</span>

//           <h2>
//             We’re Ready To Help Your Shipping Business Grow Efficiently
//           </h2>

//           <p>
//             Whether you need freight forwarding, cargo handling, international
//             shipping, or logistics support, our experienced team is available
//             to assist you with fast and reliable service.
//           </p>

//           <div className="contact-info-wrapper">
//             <div className="contact-info-card">
//               <div className="contact-icon">
//                 <FaMapMarkerAlt />
//               </div>

//               <div>
//                 <h4>Office Location</h4>
//                 <p>Monrovia, Liberia, Johnsonville, Pipeline Road, Kpelleh Town</p>
//               </div>
//             </div>

//             <div className="contact-info-card">
//               <div className="contact-icon">
//                 <FaPhoneAlt />
//               </div>

//               <div>
//                 <h4>Call Us</h4>
//                 <p>+231 773 275 388 / +231 889 239 865</p>
//               </div>
//             </div>

//             <div className="contact-info-card">
//               <div className="contact-icon">
//                 <FaEnvelope />
//               </div>

//               <div>
//                 <h4>Email Address</h4>
//                 <p>zulushipping@gmail.com</p>
//               </div>
//             </div>
//           </div>

//           {/* SOCIALS */}
//           <div className="social-links">
//             <a href="/">
//               <FaFacebookF />
//             </a>

//             <a href="/">
//               <FaInstagram />
//             </a>

//             <a href="/">
//               <FaLinkedinIn />
//             </a>
//           </div>
//         </div>

//         {/* RIGHT SIDE */}
//         <div className="contact-right">
//           <img src={contactImage} alt="Shipping Company" />

//           <div className="floating-card">
//             <h3>Fast & Secure Delivery</h3>
//             <p>
//               Trusted cargo and shipping services with professionalism and
//               customer satisfaction at the center.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* CONTACT FORM SECTION */}
//       <section className="contact-form-section">
//         <div className="form-container">
//           <div className="form-left">
//             <h2>Send Us A Message</h2>

//             <p>
//               Fill out the form below and our support team will get back to you
//               as soon as possible.
//             </p>
//           </div>

//           <form className="contact-form">
//             <div className="form-group">
//               <input type="text" placeholder="Your Full Name" />
//             </div>

//             <div className="form-group">
//               <input type="email" placeholder="Your Email Address" />
//             </div>

//             <div className="form-group">
//               <input type="text" placeholder="Phone Number" />
//             </div>

//             <div className="form-group">
//               <textarea rows="6" placeholder="Write Your Message..." />
//             </div>

//             <button type="submit">Send Message</button>
//           </form>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ContactPage;